import UploadFiles, { IUploadFilesChildren } from './UploadFiles'
import UploadFilesWithModal, { IUploadImageWithModal } from './UploadFilesWithModal'

export default UploadFiles
export { UploadFilesWithModal }
export type { IUploadImageWithModal, IUploadFilesChildren }
